import { Entity } from '@backstage/catalog-model';
import {
  EntityFilter,
  EntityLifecycleFilter,
  EntityNamespaceFilter,
  EntityOrphanFilter,
  EntityOwnerFilter,
  EntityTagFilter,
  EntityTextFilter,
  EntityUserFilter,
} from '@backstage/plugin-catalog-react';

export interface CatalogFilters {
  filter: Record<string, string | symbol | (string | symbol)[]>;
  fullTextFilter?: {
    term: string;
  };
}

function isEntityTextFilter(t: EntityFilter): t is EntityTextFilter {
  return !!(t as EntityTextFilter).getFullTextFilters;
}

export function reduceCatalogFilters(filters: EntityFilter[]): CatalogFilters {
  const condensedFilters = filters.reduce<CatalogFilters['filter']>(
    (compoundFilter, filter) => {
      return {
        ...compoundFilter,
        ...(filter.getCatalogFilters ? filter.getCatalogFilters() : {}),
      };
    },
    {},
  );

  const fullTextFilter = filters.find(isEntityTextFilter)?.getFullTextFilters();
  return { filter: condensedFilters, fullTextFilter };
}

export function reduceBackendCatalogFilters(filters: EntityFilter[]) {
  const backendCatalogFilters: Record<
    string,
    string | symbol | (string | symbol)[]
  > = {};

  filters.forEach(filter => {
    if (
      filter instanceof EntityTagFilter ||
      filter instanceof EntityOwnerFilter ||
      filter instanceof EntityLifecycleFilter ||
      filter instanceof EntityNamespaceFilter ||
      filter instanceof EntityUserFilter ||
      filter instanceof EntityOrphanFilter ||
      filter instanceof EntityTextFilter
    ) {
      return;
    }
    Object.assign(backendCatalogFilters, filter.getCatalogFilters?.() || {});
  });

  return backendCatalogFilters;
}

export function reduceEntityFilters(
  filters: EntityFilter[],
): (entity: Entity) => boolean {
  return (entity: Entity) =>
    filters.every(
      filter => !filter.filterEntity || filter.filterEntity(entity),
    );
}
